// @vendors
const get = require('lodash/object/get');
const reduce = require('lodash/collection/reduce');
const trim = require('lodash/string/trim');
const momentTz = require('moment-timezone');
const Immutable = require('immutable');

// @utilities
const apiURLBuilder = require('../core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { es: { DATE_FORMAT_WITH_DASHES_DATETIME }} = require('commonsConstants/dateFormatTypes');
const { getConfirmationPDFSharesAmount } = require('utilities/pdfDocumentsHelper');
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
const translateExantCostKey = require('utilities/translationExantCost');

// @constants
const {
    BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID,
    BROKER_ALERT_BUY_BUTTON_STOCK,
    BROKER_ORDER_TYPE_BUY,
    BROKER_PRODUCT_TYPE_STOCKS,
    CHARGE_ACCOUNT_PREFIX,
    FIRST_STEP,
    SECOND_STEP,
    FOR_THE_BEST_CODE,
    LIMITED_CODE,
    TO_MARKET_CODE,
    BROKER_STOCKS_BUY_STEP1_BUY_FOR,
    BROKER_STOCKS_BUY_APPROX_IMPORT,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST_DESCRIPTION,
    BROKER_ORDER_TYPE_LIMITED_DESCRIPTION,
    BROKER_ORDER_TYPE_TO_MARKET_DESCRIPTION,
    BROKER_STOCKS_BUY_NO_RESTRICTION,
    CONNECTION_CHANNEL_INTERNET,
    BROKER_MIFID_VERSION_2,
    INTERVENER_TYPE_PROPIETARIO,
    BROKER_HOLIDAY_VALIDATION_ERROR,
    BROKER_MIFID_STOCK_PDF_AMOUNT_DECIMALS,
    WIZARD_SECOND_STEP,
    SPANISH_MARKETS_ISO_CODE,
    API_CHANNEL
} = require('constants/index');
const actionTypes = require('constants/actionTypes');

// @actions
const errorActions = require('actions/brokerError');
const signaturePatternActions = require('actions/signaturePattern');
const { outdateGlobalPosition } = require('actions/myGlobalPosition');
const { outdateMyInvestments } = require('actions/brokerMyInvestments');
const brokerIntervenerActions = require('actions/brokerInterveners');
const { brokerStocksOperationFailure } = require('actions/brokerStocksOperationFailure');

function reset() {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_RESET
    };
}

function signaturePatternSuccess(token) {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_SIGNATURE_SUCCESS,
        payload: {
            token
        }
    };
}

function setVisibleStep(step) {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

function setWillLeave() {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_WILL_LEAVE
    };
}

function resetLotValuesByLot(){
    return {
        type: actionTypes.BROKER_STOCKS_BUY_RESET_ERRORS_BY_LOT,
    };
}

function setWillCancel(value) {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_WILL_CANCEL,
        payload: {
            value
        }
    };
}

function validateUIStep(step, catalogData) {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_VALIDATE_STEP,
        payload: {
            step,
            catalogData
        }
    };
}

function resetStep1TitlesInput() {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_RESET_STEP_1_TITLES_INPUT
    };
}

function resetStep1ApproxImportInput() {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_RESET_STEP_1_APPROX_IMPORT_INPUT
    };
}

function resetStep1LimitedInput() {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_RESET_STEP_1_LIMITED_INPUT
    };
}

const updateStep1Form = (formData, productPrice, catalogData) => {
    if (productPrice) {
        return {
            type: actionTypes.BROKER_STOCKS_BUY_UPDATE_STEP_1_FORM,
            payload: {
                formData,
                productPrice: productPrice,
                catalogData
            }
        };
    } else {
        return {
            type: actionTypes.BROKER_STOCKS_BUY_UPDATE_STEP_1_FORM,
            payload: {
                formData
            }
        };
    }
};

function validationSuccess(response) {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_VALIDATE_SUCCESS,
        payload: {
            data: response
        }
    };
}

function validationFailure(response) {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_VALIDATE_FAILURE,
        payload: {
            data: response
        }
    };
}

function validationRequest() {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_VALIDATE_REQUEST
    };
}

function confirmationSuccess(response) {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_CONFIRM_SUCCESS,
        payload: {
            data: response
        }
    };
}

function confirmationFailure(response) {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_CONFIRM_FAILURE,
        payload: {
            data: response
        }
    };
}

function confirmationRequest() {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_CONFIRM_REQUEST
    };
}

function sendOrderSummaryEmailRequest() {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_SEND_EMAIL_REQUEST
    };
}

function sendOrderSummaryEmailSuccess() {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_SEND_EMAIL_SUCCESS
    };
}

function sendOrderSummaryEmailError() {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_SEND_EMAIL_ERROR
    };
}

function extantCostRequest() {
    return {
        type: actionTypes.BROKER_STOCKS_EXTANTCOST_FECHING,
    };
}

function extantCostSuccess(data) {
    return {
        type: actionTypes.BROKER_STOCKS_EXTANTCOST_SUCESS,
        payload: data
    };
}

function extantCostError(error) {
    return {
        type: actionTypes.BROKER_STOCKS_EXTANTCOST_ERROR,
        payload: error
    };
}

const getExtantCostDetails = (history) => (dispatch, getState) => {
    const immStepOne = getState()['brokerStocksBuy'].getIn(['steps', FIRST_STEP])
    const immOrderType = immStepOne.getIn(['orderType']);
    let orderType = '';
    let limitedPrice = null;
    let sharesAmount = null;
    let sharesNumber = null;

    const buyFor = immStepOne.getIn(['buyFor']);

    if (buyFor === "aproxImport") {
        sharesAmount = {
            amount: immStepOne.getIn(['buyForConditionalInput']),
            currency: getState().brokerProductFile.get('currency'),
            descriptionKey: null,
            percentage: null,
            tooltipKey: null,
            type: null
        }
    } else if (buyFor === 'titleAmount') {
        sharesAmount = null;
        sharesNumber = immStepOne.getIn(['buyForInput']);
    }

    switch (immOrderType) {
        case 'toMarket':
            orderType = 'MARKET';
            break;
        case 'forTheBest':
            orderType = 'BEST';
            break;
        case 'limited':
            orderType = 'LIMITED';
            limitedPrice = {
                amount: immStepOne.getIn(['orderTypeLimited']),
                currency: getState().brokerProductFile.get('currency'),
                descriptionKey: null,
                percentage: null,
                tooltipKey: null,
                type: null
            }
            break;
    }

    const selectedOption = immStepOne.getIn(['stocksContractSelectedValue']);
    const contract = getState().brokerStocksContract.get(selectedOption);
    const channelForRequest = __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL;
    const requestData = {
        channel: channelForRequest,
        contract: {
          number: contract.get('walletNumber'),
          product: contract.get('productNumber')
        },
        instrumentType: 'STOCK',
        isin: getState().brokerProductFile.get('isinCode'),
        limitedPrice,
        market: getState().brokerProductFile.get('micCode'),
        operationType: 'C',
        orderType,
        sharesAmount,
        sharesNumber
    }

    dispatch(extantCostRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerGetExAnteCost'), { query: requestData }).then(
        function (response) {
            dispatch(extantCostSuccess(response));
        },
        function (error) {
            const errorKey = get(error, ['body', 'error'], '') || error.error;
            dispatch(extantCostError(error));
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        }
    );
}

function getValidationData(getState) {
    const validationData = {
        descripcionRestriccion: BROKER_STOCKS_BUY_NO_RESTRICTION,
        tipoNegociacion: '0',
        tipoRestriccion: '0'
    };

    const orderTypes = {};

    orderTypes[BROKER_ORDER_TYPE_FOR_THE_BEST] = {
        code: FOR_THE_BEST_CODE,
        orderDescription: BROKER_ORDER_TYPE_FOR_THE_BEST_DESCRIPTION
    };
    orderTypes[BROKER_ORDER_TYPE_LIMITED] = {
        code: LIMITED_CODE,
        orderDescription: BROKER_ORDER_TYPE_LIMITED_DESCRIPTION
    };
    orderTypes[BROKER_ORDER_TYPE_TO_MARKET] = {
        code: TO_MARKET_CODE,
        orderDescription: BROKER_ORDER_TYPE_TO_MARKET_DESCRIPTION
    };

    const operationFirstStep = getState()['brokerStocksBuy'].getIn(['steps', FIRST_STEP]);
    const orderType = operationFirstStep.get('orderType');
    const validityDate = operationFirstStep.get('validityDate');
    const buyFor = operationFirstStep.get(BROKER_STOCKS_BUY_STEP1_BUY_FOR);
    const catalogData = getState().brokerProductFile.get('catalogData');
    const currency = getState().brokerProductFile.get('currency');

    if (buyFor === BROKER_STOCKS_BUY_APPROX_IMPORT) {
        if(!catalogData.get('operatedByLot')) {
            validationData['importeAprximado'] = {
                divisa: currency,
                importe: operationFirstStep.get('buyForConditionalInput')
            };
        } else {
            validationData['numTitulos'] = operationFirstStep.get('buyForConditionalInput_titlesToBuy');
        }

        if (getState().brokerStocksBuy.getIn(['confirmationData'])) {
            validationData['numTitulos'] = getState().brokerStocksBuy.getIn([
                'confirmationData'
            ]).titulosImporteAproximado;
        }
    } else {
        validationData['numTitulos'] = operationFirstStep.get('buyForInput');
    }

    if (orderType === BROKER_ORDER_TYPE_LIMITED) {
        validationData['importeLimitada'] = {
            divisa: currency,
            numeroimportevalores: operationFirstStep.get('orderTypeLimited')
        };
    } else {
        validationData['importeLimitada'] = {
            divisa: currency,
            numeroimportevalores: 0
        };
    }

    validationData['tipoOrden'] = orderTypes[orderType].code;
    validationData['descripcionOrden'] = orderTypes[orderType].orderDescription;
    validationData['plazoValidez'] = validityDate.format('YYYY-MM-DD');

    return validationData;
}

const getInterveners = () => (dispatch, getState) => {
    const operationFirstStep = getState()['brokerStocksBuy'].getIn(['steps', FIRST_STEP]);
    const selectedOption = operationFirstStep.get('stocksContractSelectedValue');
    const contract = getState().brokerStocksContract.get(selectedOption);

    const wallet = Immutable.fromJS({
        accountNumber: contract.get('walletNumber'),
        product: contract.get('productNumber')
    })
    dispatch(brokerIntervenerActions.getIndexes(wallet));
}

const validateWithAPI = (history) => (dispatch, getState) => {
    const operationFirstStep = getState()['brokerStocksBuy'].getIn(['steps', FIRST_STEP]);
    const valid = operationFirstStep.get('valid');
    if (!valid) {
        return;
    }

    let requestData, data;

    const selectedOption = operationFirstStep.get('stocksContractSelectedValue');
    const isinCode = getState().brokerProductFile.get('isinCode');
    const micCode = getState().brokerProductFile.get('micCode');
    const contract = getState().brokerStocksContract.get(selectedOption);

    requestData = {
        codigoISIN: isinCode,
        codigoISO: micCode,
        contratoValores: {
            numerodecontrato: contract.get('walletNumber'),
            producto: contract.get('productNumber')
        },
        datosValidacion: getValidationData(getState),
        digitoControl: contract.get('controlDigit'),
        discriminadorClausula: 'N',
        tipoOperacion: 'C'
    };

    data = {
        query: requestData
    };

    dispatch(validationRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('stocksSimpleBuyValidation'), data).then(
        function (response) {
            dispatch(validationSuccess(response));
            dispatch(getInterveners());
        },
        function (response) {
            dispatch(validationFailure(response));
            const errorKey = get(response, ['body', 'error'], '') || response.error;
            if (errorKey !== BROKER_HOLIDAY_VALIDATION_ERROR) {
                dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
            }
        }
    );
};

const generateMiFIDDisclaimers = (immBrokerConvenienceMiFIDTest) => {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
    const immAllDisclaimers = Immutable.fromJS([]).merge(immUSPersonDisclaimers).merge(immDisclaimers);

    return immAllDisclaimers.map((immDisclaimer, index) => {
        const disclaimer = index === 0 && immDisclaimer.get('phrase')
        ? `${immDisclaimer.get('description')} ${immDisclaimer.get('phrase')}`
        : immDisclaimer.get('description')
        return disclaimer
    }).join(' | ');
};

const getHolders = (contract, interveners) => {
    let holderNames = [];
    if (interveners.size > 0) {
        const holders = interveners.filter((intervener) => {
            return intervener.get('tipoIntervencion').trim() === INTERVENER_TYPE_PROPIETARIO
        });
        holderNames = holders.map(holder => {
            return holder.get('nomInterviniente').trim()
        });
    } else {
        const holder = contract.get('walletTitular');
        holderNames.push(holder)
    }
    return holderNames;
}

const sendOrderSummaryEmail = (response) => (dispatch, getState) => {
    let communicationServiceInput, data;
    const immProfile = getState().profile;
    const immBrokerProductFile = getState().brokerProductFile;
    const immFeatureFlags = getState().flagBasedFeatures;
    const showExtantCost = immFeatureFlags.get('wealth_stocks_buy_show_costs');
    const immBrokerStocksBuy = getState().brokerStocksBuy;
    const immExanteData = immBrokerStocksBuy.get('extantCostData');
    const exantCostsData = !!immExanteData.getIn(["exAnteCostList"])
        ? translateExantCostKey(
              immExanteData.getIn(["exAnteCostList"]).toJS(),
              "brokerBuyStockExAnte",
              "PROFITABILITY",
              "brokerBuyStockExAnteProfitability"
          )
        : null;
    const dataValidation = getValidationData(getState);
    const selectedOption = getState()['brokerStocksBuy'].getIn(['steps', FIRST_STEP, 'stocksContractSelectedValue']);
    const contract = getState().brokerStocksContract.get(selectedOption);
    const contractNumber = contract.get('walletNumber');
    const productNumber = contract.get('productNumber');
    const controlDigit = contract.get('controlDigit');
    const securityAccount = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${contractNumber}`;
    const operationFirstStep = getState()['brokerStocksBuy'].getIn(['steps', FIRST_STEP]);
    const productAmount = Number(immBrokerProductFile.getIn(['productValue', 'amount'])) || 0;
    const shareNumber = dataValidation.numTitulos;
    const isLimitedOrder = immBrokerStocksBuy.getIn(['steps', FIRST_STEP, 'orderType']) === BROKER_ORDER_TYPE_LIMITED;
    const isBuyForAmountOrder = immBrokerStocksBuy.getIn(['steps', FIRST_STEP, 'buyFor']) === BROKER_STOCKS_BUY_APPROX_IMPORT;
    const amountInput = immBrokerStocksBuy.getIn(['steps', FIRST_STEP, 'buyForConditionalInput']);
    const sharesAmount = getConfirmationPDFSharesAmount({
        isLimitedOrder,
        isBuyForAmountOrder,
        amountInput,
        sharesNumber: shareNumber,
        lastPrice: productAmount,
        decimals: BROKER_MIFID_STOCK_PDF_AMOUNT_DECIMALS
    });
    const marketName = getState().brokerProductFile.get('marketName');
    const emittedDateTime = momentTz(parseInt(get(response, 'timestamp', ''), 10)).tz("Europe/Madrid");
    const interveners = getState().brokerInterveners.get('list');
    const holderNames = getHolders(contract, interveners);
    const conditionPrice = operationFirstStep.get('orderTypeLimited') ? operationFirstStep.get('orderTypeLimited') : '';

    communicationServiceInput = {
        "email": PersonalDataHelper.getEmail(immProfile),
        "productKID": "",
        "contract": "",
        "marketingReport": "",
        "infoCcv": "",
        "sendOrder": "No",
        "ccc": get(response, ['datosCuentaAsociada', 'codIban', 'codbban'], '').trim(),
        "ccv": securityAccount,
        "idContract": securityAccount,
        "conditionPrize": "" + conditionPrice + "",
        "currency": get(response, ['datosCuentaAsociada', 'saldoCuentaAsociada', 'divisa'], ''),
        "holders": holderNames.join(','),
        "idOrder": get(response, 'numeroOrden', ''),
        "isin": getState().brokerProductFile.get('isinCode'),
        "isinDescribe": getState().brokerProductFile.get('companyName'),
        "market": marketName,
        "orderCondition": dataValidation.descripcionOrden,
        "orderType": BROKER_ORDER_TYPE_BUY,
        "productType": BROKER_PRODUCT_TYPE_STOCKS,
        "sharesAmount": sharesAmount,
        "sharesNumber": "" + shareNumber + "",
        "termValidity": dataValidation.plazoValidez,
        "clientAlias": immProfile.get('nombreCliente'),
        "channel": CONNECTION_CHANNEL_INTERNET,
        "mifidWarningText": generateMiFIDDisclaimers(getState().brokerConvenienceMiFIDTest),
        "dateTime": emittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME)
    };
    const url = 'communication';
    if (showExtantCost) {
        const estimatedBaseAmount = immExanteData.getIn([
            "estimatedBaseAmount",
            "amount",
        ])
            ? immExanteData.getIn(["estimatedBaseAmount", "amount"])
            : null;
        data = {
            query: {
                ...communicationServiceInput,
                sharesAmount: estimatedBaseAmount,
                exAnteCostsList: exantCostsData
            }
        };
    } else {
        data = {
            query: communicationServiceInput
        };
    }
   dispatch(sendOrderSummaryEmailRequest());
    return APIPost(dispatch, apiURLBuilder.getURL(url), data).then(
        function () {
            dispatch(sendOrderSummaryEmailSuccess());
        },
        function () {
            dispatch(sendOrderSummaryEmailError());
        }
    );
}

const mifidDisclaimersResponse = (immBrokerConvenienceMiFIDTest) => {
    const isUsingMifidv2 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_2;
    let disclaimers = undefined;

    if (isUsingMifidv2) {
        const mifidv2AllDisclaimers =
            immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers'])
                .merge(immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']))
                .toJS();

        disclaimers = reduce(mifidv2AllDisclaimers, (result, disclaimer, index) => {
            const disclaimerKey = `disclaimer_${index + 1}`;
            let disclaimerText;
            if (index === 0 && !!get(disclaimer, 'phrase')){
                disclaimerText = `${trim(get(disclaimer, 'description'))} ${get(disclaimer, 'phrase')}`
            } else{
                disclaimerText = trim(get(disclaimer, 'description'));
            }
            result[disclaimerKey] = `${trim(get(disclaimer, 'id'))} | ${disclaimerText}`;

            return result;
        }, {});
    }

    return disclaimers;
};

const confirmStocksBuy = (history) => (dispatch, getState) => {
    const operationSecondStep = getState()['brokerStocksBuy'].getIn(['steps', SECOND_STEP]);
    const valid = operationSecondStep.get('valid');
    if (!valid) {
        return;
    }
    const operationFirstStep = getState()['brokerStocksBuy'].getIn(['steps', FIRST_STEP]);
    const dataToken = getState()['brokerStocksBuy'].get('token');
    const confirmationData = getState()['brokerStocksBuy'].get('confirmationData');
    const executionData = confirmationData.datosEjecucion; //confirmationData.accionesVentaValidacion.datosEjecucion;
    const emitData = confirmationData.datosEmision; //confirmationData.accionesCodigoEmisionValor;
    const selectedOption = operationFirstStep.get('stocksContractSelectedValue');
    const contract = getState().brokerStocksContract.get(selectedOption);
    const immBrokerProductFile = getState().brokerProductFile;
    const isinCode = immBrokerProductFile.get('isinCode');
    const micCode = immBrokerProductFile.get('micCode');
    const isSpain = SPANISH_MARKETS_ISO_CODE.includes(micCode.toLowerCase());
    const dataValidation = getValidationData(getState);
    const shares = get(confirmationData, 'titulosImporteAproximado');
    const codigoDisclaimer = getState().brokerMiFIDProducts.getIn(['products', BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID, 'codigoDisclaimer']);

    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const mifidScore = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'score']);
    const mifidScoring = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'scoring']);
    const mifidWasApplied = immBrokerConvenienceMiFIDTest.get('started');
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const uuid = immBrokerLegalDocumentation.get('uuid');

    const data = {
        contratoValores: {
            numerodecontrato: contract.get('walletNumber'),
            producto: contract.get('productNumber')
        },
        dataToken: dataToken,
        datosEjecucion: {
            codigoGrupoSector: executionData.codigoGrupoSector,
            codigoOrganismoEjecucion: executionData.codigoOrganismoEjecucion,
            codigoValorJuntSind: executionData.codigoValorJuntSind,
            codvalorSib: executionData.codvalorSib,
            indicadorCompensacion: executionData.indicadorCompensacion,
            indicadorContingencia: executionData.indicadorContingencia,
            indicadorEnvioRecepcion: executionData.indicadorEnvioRecepcion,
            nominalTitulo: {
                divisa: executionData.nominalTitulo.divisa,
                importe: executionData.nominalTitulo.importe
            },
            tipoCotizacion: executionData.tipoCotizacion,
            tipoMercado: executionData.tipoMercado,
            tipoOperacion: 'C',
            titulosNominalMinEjec: 0,
            tratamientoEmision: executionData.tratamientoEmision
        },
        datosEmision: {
            codEmision: emitData.codEmision,
            codMercado: emitData.codMercado,
            codValor: emitData.codValor
        },
        datosValidacion: dataValidation,
        convenienceTest: codigoDisclaimer,
        productIsin: isinCode,
        productType: BROKER_ALERT_BUY_BUTTON_STOCK,
        shares: shares,
        initQuantity: shares,
        unitPrice: immBrokerProductFile.get('buyPrice'),
        productManager: immBrokerProductFile.get('companyName'),
        micCode: micCode,
        convenientRegistry: immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'isConvenient']),
        evaluateRegistry: mifidWasApplied,
        disclaimers: mifidDisclaimersResponse(immBrokerConvenienceMiFIDTest),
        marketTargetRegistry: mifidScore >= mifidScoring,
        necessaryConvenienceTestNote: mifidScoring,
        necessaryTargetMarketNote: immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'targetMarketKnowledgeAndExperience']),
        testConveniencyResult: mifidScore,
        documentationId: uuid
    };

    if (isSpain) {
        data.datosEjecucion['codigoBolsa'] = '1';
    }

    const requestData = {
        header: {
            version: 2
        },
        query: data
    };

    dispatch(confirmationRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('confirmStocksBuySell'), requestData).then(
        function (response) {
            dispatch(sendOrderSummaryEmail(response));
            dispatch(confirmationSuccess(response));
            dispatch(outdateGlobalPosition());
            dispatch(outdateMyInvestments());
        },
        function (response) {
            dispatch(confirmationFailure(response));
            dispatch(brokerStocksOperationFailure(response, history));
        }
    );
};

const requestSignaturePatternValidation = (history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        dispatch(signaturePatternSuccess(dataToken));
        dispatch(confirmStocksBuy(history));//Calling actions in sync to use the data token in confirmStocksBuy
    };
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

const finish = (history) => dispatch => {
    dispatch(requestSignaturePatternValidation(history));
};

const validateStep = (step, history) => (dispatch, getState) => {
    const catalogData = getState().brokerProductFile.get('catalogData');
    dispatch(validateUIStep(step, catalogData));

    if (step !== WIZARD_SECOND_STEP) {
        dispatch(validateWithAPI(history));
    }
    else {
        dispatch(finish(history));
    }
};

function setHolidayError() {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_SET_HOLIDAY_ERROR
    };
}

module.exports = {
    reset,
    setVisibleStep,
    setWillLeave,
    setWillCancel,
    validateStep,
    finish,
    resetStep1TitlesInput,
    resetStep1ApproxImportInput,
    resetStep1LimitedInput,
    resetLotValuesByLot,
    updateStep1Form,
    setHolidayError,
    getExtantCostDetails
};
